import { CANONICAL_SITE_ORIGIN } from './sharing.js';

/**
 * Accept only a public URL on Entangled Vega's canonical HTTPS origin.
 * Hash state is intentionally excluded because it is not part of the
 * application's canonical, shareable URL contract.
 */
export function canonicalPublicUrl(value: string): string {
  let url: URL;
  try {
    url = new URL(value);
  } catch {
    throw new Error('A valid canonical Entangled Vega URL is required.');
  }

  if (
    url.protocol !== 'https:' ||
    url.origin !== CANONICAL_SITE_ORIGIN ||
    url.username.length > 0 ||
    url.password.length > 0
  ) {
    throw new Error('The public URL must use the canonical Entangled Vega HTTPS origin.');
  }

  url.hash = '';
  return url.href;
}
